import { GridColumn } from '@tkww/orion-web-ds-structure';
import classNames from 'classnames';
import React from 'react';
import type { FC, RefObject } from 'react';

import { AwardItems } from '../../../../components/award-items/AwardItems';
import Styles from './styles.scss';

interface AwardsProps {
	fullWidth?: boolean;
	columnSize?: '6' | '12';
	trackingRef?: RefObject<HTMLDivElement>;
}

export const Awards: FC<AwardsProps> = ({
	fullWidth = false,
	columnSize = '6',
	trackingRef,
}) => {
	const columnWidth = fullWidth ? '12' : columnSize;
	return (
		<GridColumn
			xs="12"
			md={columnWidth}
			className={classNames({
				[Styles.fullWidth]: fullWidth,
			})}
		>
			<div ref={trackingRef}>
				<div
					data-testid="awards-and-affiliations-heading"
					className={classNames({
						[Styles.awardTitleBold]: fullWidth,
						[Styles.awardTitle]: !fullWidth,
					})}
				>
					Awards and Affiliations
				</div>
				<div className={Styles.awards}>
					<AwardItems />
				</div>
			</div>
		</GridColumn>
	);
};
